const ComponentWrapper = ({ render = true, children }) => {
  if (!render) return null;
  
  return (
    <div className="px-12 max-xs:px-6 py-6">
      {children}
    </div>
  );
};

export default ComponentWrapper;
